import styled from 'styled-components'
import { Link } from 'react-router-dom'

const BuildingNameLink = styled(Link)`
  font-size: ${(p) => p.theme.font.size.l};
  font-weight: bold;
  color: #008df3;

  text-decoration: underline;
`
const ListFiledBuildingName = ({
  name,
  url,
}: {
  name: string | null
  url: string
}) => {
  const displayName = !!name ? name : '不明'

  if (!url) {
    return <>{displayName}</>
  }

  return (
    <BuildingNameLink to={url} target={'_blank'}>
      {displayName}
    </BuildingNameLink>
  )
}

export default ListFiledBuildingName
